// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ok-5";
export var filledCircle = "_ok-4";
export var historyEntry = "_ok-3";
export var messageSideLeft = "_ok-1";
export var messageSideRight = "_ok-2";
export var orderTrackingCarouselWrapper = "_ok-6";
export var orderTrackingInfoContainer = "_ok-0";